import { TmaEvent, TrackingModel } from "../../models/models"
import { TmaSender } from "../tma-sender"
import { RepairTimeChanged } from "./models"

export class RepairTimesChangedEventHandler extends TmaSender<RepairTimeChanged[]> implements TmaEvent {
    key = "REPAIRTIMES_CHANGED"

    static serviceEndpoint = "/general/repairTimesChanged"

    constructor() {
        super(RepairTimesChangedEventHandler.serviceEndpoint)

        this.requestBody = []
    }

    handle = (trackingData: TrackingModel<RepairTimeChanged[]>): boolean => {
        if (!trackingData.tmaEvent || trackingData.tmaEvent !== this.key || !trackingData.payload) {
            return false
        }

        if (!this.requestBody) {
            this.requestBody = []
        }

        if (trackingData.bundle === "general") {
            if (Array.isArray(trackingData.action)) {
                trackingData.action.forEach((action) => this.fillRequest(trackingData.payload, action))
            } else {
                this.fillRequest(trackingData.payload, trackingData.action)
            }
            return true
        }

        return false
    }

    fillRequest = (trackingData: RepairTimeChanged[] | undefined, action: string) => {
        if (!trackingData) {
            return
        }

        if (action === "repairtimes_changed_called") {
            if (trackingData) {
                this.requestBody = trackingData
            }

            this.sendEvent()
        }
    }
}
